"use client";

import PermissionsForm from "@/components/templates/PermissionsForm";
import { IProfile } from "@/interfaces/permission.interfaces";
import IUser from "@/interfaces/user.interface";
import { ProfileMessages } from "@/messages/profile/profile.messages";
import { PaginatedResponse } from "@/types/requests.types";

type Props = {
  messages: ProfileMessages;
  user: IUser;
  permissions: PaginatedResponse<IProfile>;
};

function Permissions({ messages, user, permissions }: Props) {
  return (
    <PermissionsForm
      user={user}
      permissions={permissions}
      successMessage={messages.insertUserProfileSuccess}
      errorMessage={messages.inserUserProfileError}
      messages={messages}
    />
  );
}

export default Permissions;
